<div class="row product-search-result" data-testing-id="search-result-page" id="search-page-top">
  <div class="marketing-area col-12">
    <ish-content-include includeId="include.searchresult.base.top.pagelet2-Include" />
  </div>

  <div class="col-md-3">
    <custom-clear-all-filter />
    {{ 'search.listing.sidenav.refinesearch.title' | translate }}
    <custom-now-shopping-navigation />
    <div class="navigation-panel" [ngbCollapse]="isCollapsed">
      <ish-skip-content-link skipToElementId="nav-breadcrumbs" linkText="common.skip_content.link.text.filter" />
      <ish-filter-navigation />
      <div class="marketing-area">
        <ish-content-include includeId="include.searchresult.navigation.pagelet2-Include" />
      </div>
    </div>
    <a [routerLink]="[]" class="d-md-none mobile-filter-toggle btn btn-link btn-link-action" (click)="toggle()">
      {{ 'search.mobile.filter.trigger' | translate }}
      <fa-icon [icon]="['fas', isCollapsed ? 'angle-down' : 'angle-up']" />
    </a>
  </div>

  <div class="col-md-9">
    <ish-breadcrumb />
    <h1>
      {{ 'search.title.text' | translate : { '1': searchTerm, '2': totalItems() } }}
    </h1>
    <div class="marketing-area">
      <ish-content-include includeId="include.searchresult.content.top.pagelet2-Include" />
    </div>
    <ish-product-listing
      [productListingId]="{ type: 'search', value: searchTerm() }"
      fragmentOnRouting="search-page-top"
    />
    <div class="marketing-area">
      <ish-content-include includeId="include.searchresult.content.bottom.pagelet2-Include" />
    </div>
  </div>

  <div class="marketing-area col-12">
    <ish-content-include includeId="include.searchresult.base.bottom.pagelet2-Include" />
  </div>
</div>
